import React from 'react';

import './button.styles.scss';

const Button = ({children}) => (
  <button className="buttonBaglantiEkle">{children}</button>
);

export default Button;